import { getItem, setItem } from '@growth/cookies';
import { C, g as generateVid } from '../../dist/helper-bc63c3dd.esm.js';
export { C as config, g as generateVid } from '../../dist/helper-bc63c3dd.esm.js';

function visitorIdBrowser(options) {
  var opts = options || {}; // if vid cookie is present

  if (getItem(C.CookieName)) {
    if (opts.debug) console.info('DEBUG visitorIdBrowser: visitorId cookie is already present in browser');
    return true;
  } // if vid is not present in cookie


  var vid = generateVid();
  setItem(C.CookieName, vid, {
    expires: C.MaxAgeDay * 24 * 60 * 60,
    path: "/",
    domain: C.Domain,
    secure: true
  });
  if (opts.debug) console.info('DEBUG visitorIdBrowser: new visitorId cookie has been set to browser');
  return true;
}

var getVisitorIdBrowser = function getVisitorIdBrowser() {
  var vid = getItem(C.CookieName);
  return vid || undefined;
};

export { getVisitorIdBrowser, visitorIdBrowser };
